const GRADUATION_YEAR_KEYWORD_REGEX = /^graduationYear(=|[<>]=?)\d+$/;
const GPA_WEIGHTED_KEYWORD_REGEX = /^gpaWeighted(=|[<>]=?)[\d.]+$/;
const GPA_UNWEIGHTED_KEYWORD_REGEX = /^gpaUnweighted(=|[<>]=?)[\d.]+$/;

const EXCLUDED_BARE_KEYWORDS = new Set(["graduationYear", "gpaWeighted", "gpaUnweighted"]);

/** Search filter keywords that should not appear on the Talent Alignment tab. */
export const isExcludedTalentAlignmentSearchKeyword = (keyword: string): boolean => {
  if (EXCLUDED_BARE_KEYWORDS.has(keyword)) {
    return true;
  }

  return (
    GRADUATION_YEAR_KEYWORD_REGEX.test(keyword) ||
    GPA_WEIGHTED_KEYWORD_REGEX.test(keyword) ||
    GPA_UNWEIGHTED_KEYWORD_REGEX.test(keyword)
  );
};
